<template>

  <div class="card-background">
    <div class="columns">

      <TournamentMenu :tournament="tournament" />

      <div class="column is-four-fifths-desktop is-four-fifths-tablet">
        <div v-if="tournament">
          <h2 class="has-text-weight-bold has-text-left is-size-3" style="margin-bottom: 30px;">{{ tournament.name }} - Dashboard</h2>


          <div class="columns is-centered is-multiline">
            <div class="column is-one-third-tablet is-one-third-desktop">
              <router-link tag="div" class="dashboard-link" :to="'/tournaments/' + tournament.id + '/events'">
                <img src="../assets/collaboration.png" />
                <p>Events</p>
              </router-link>
            </div>

            <div class="column is-one-third-tablet is-one-third-desktop">
              <router-link tag="div" class="dashboard-link" :to="'/tournaments/' + tournament.id + '/teams'">
                <img src="../assets/bus.png" />
                <p>Teams</p>
              </router-link>
            </div>


            <div class="column is-one-third-tablet is-one-third-desktop">
              <router-link tag="div" class="dashboard-link" :to="'/tournaments/' + tournament.id + '/matches'">
                <img src="../assets/scoreboard_alt.png" style="opacity: 0.75;" />
                <p>Matches</p>
              </router-link>
            </div>





            <div class="column is-one-third-tablet is-one-third-desktop">
              <router-link tag="div" class="dashboard-link" :to="'/tournaments/' + tournament.id + '/events/add'">
                <img src="../assets/calendar.png" />
                <p>Add event</p>
              </router-link>
            </div>


            <div class="column is-one-third-tablet is-one-third-desktop">
              <router-link tag="div" class="dashboard-link" :to="'/tournaments/' + tournament.id + '/teams/add'">
                <img src="../assets/collaboration.png" />
                <p>New team</p>
              </router-link>
            </div>
          </div>



          <div class="columns is-centered is-multiline">
            <div class="column is-full-desktop">
              <hr style="margin-top: 60px;" />
              <p class="has-text-centered" style="margin-top: 12px;">The "Events" link contains the list of events organized during the tournament.<br /> For each event, you can specify entries and specific draws played during the event.</p>
              <hr />
              <p class="has-text-centered" style="margin-top: 20px;">Teams are organisations which bring players to the tournament.<br /> For each team, you need to specify their name and coach. This allows you to quickly view the team of each player/entry.</p>
              <hr />
              <p class="has-text-centered" style="margin-top: 20px; margin-bottom: 40px;">The "Matches" link contains a link to all matches organized during the tournament.<br /> However, you may also view matches specific to each event, by first visiting the "Events" link and choosing an event.</p>

              <div class="has-text-right">
                <button class="button is-warning is-small" style="margin-right: 50px;" @click="clearTournamentDraws">Clear draws</button>

                <router-link tag="button" class="button is-link is-small" :to="'/tournaments/' + tournament.id + '/edit'">Edit basic info</router-link> &nbsp;
                <button class="button is-danger is-small" @click="deleteTournament">Delete tournament!</button>
              </div>
            </div>
          </div>
        </div>

        <div v-if="!tournament">
          <b-loading />
        </div>


      </div>

    </div>
  </div>

</template>

<script>

import TournamentDataMixin from "../mixins/TournamentDataMixin.js";
import TournamentMenu from "../components/TournamentMenu.vue";

export default {
  mixins: [ TournamentDataMixin ],

  computed: {
    tournaments: function(){ return this.$store.state.tournaments; }
  },

  methods: {
    deleteTournament() {
      this.$dialog.confirm({
        message: 'Are you sure you want to delete this tournament?',
        type: 'is-danger',
        onConfirm: () => { this.$store.dispatch('deleteItem', { type: 'tournament', item: this.tournament }); }
      });
    },

    clearTournamentDraws() {
      this.$dialog.confirm({
        message: 'Are you sure you want to clear all draws (and results)?',
        type: 'is-danger',
        onConfirm: () => { this.$store.dispatch('clearDraws', { id: this.tournament.id }); }
      });
    }
  },

  components: { TournamentMenu },
  name: 'tournament'
}
</script>



<style scoped>

  div.dashboard-link {
    text-align: center;
    margin-top: 30px;
    margin-bottom: 20px;
    padding: 13px 0;

    cursor: pointer;
  }

  div.dashboard-link img {
    width: 85px;
    height: 85px;
  }

  div.dashboard-link p {
    margin: 0;
    padding-top: 10px;
    font-weight: bold;
    font-size: 1.5rem;

    color: #5770aa;
  }
</style>